import React from 'react';

const Loader = () => {
  return (
    <div style={styles.overlay}>
      {/* Safely inject the keyframes using a style tag instead of document.styleSheets */}
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
      <div style={styles.spinner}></div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999,
  },
  spinner: {
    width: '50px',
    height: '50px',
    border: '6px solid #ccc',
    borderTop: '6px solid var(--brand-gold)',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
  },
};

export default Loader;